import React, {forwardRef, KeyboardEvent, RefObject, useCallback, useEffect, useImperativeHandle, useRef} from 'react'
import { EntitySelectorListType } from '../../../../../gd-components/entity-selector/@const'
import { SystemStatusFilter } from '../../../../../gd-components/finder/task/@types'
import TaskFinder from '../../../../../gd-components/finder/task/task-finder'
import Task from '../../../../../model2/task/task'


type Props = {
    search              : string
    listType            : EntitySelectorListType

    parentProjectId?    : ID
    excludedTasksIds?   : ID[]

    onEntitySelected    : {(entity:Task):void}
    onTab?              : {():void}
}

const debug = false
// const debug = "EntitySelectorTasksList"

const FieldSelectTask_Popover_SelectorTaskList = forwardRef((props:Props, ref) => {
    debug && console.log(debug, 'render', props)

    const taskFinderRef:RefObject<any> = useRef()

    const searchString = props.search?.toLowerCase()

    useEffect(() => {
        taskFinderRef.current?.onSearchChange(searchString)
    }, [searchString]);

    useEffect(() => {
        taskFinderRef.current?.onSearchCancel()
    }, [props.listType]);

    const onKeyDown = useCallback((event:KeyboardEvent) => {
        taskFinderRef.current.onKeyDown(event)
    }, [])

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        onKeyDown,
    }))

    const onClickTask = useCallback((task: Task)=>{
        debug && console.log(debug, 'onClickTask', task)

        props.onEntitySelected(task)
    }, [])

    debug && console.log(debug, 'render', props)

    const styles = {
        height : "calc(100% - 54px)"
    }

    const showRecentTasks = !props.search && props.listType === EntitySelectorListType.RECENT

    debug && console.log(debug, 'render', showRecentTasks, props)

    return (
        <div className="entity-selector-list" style={styles}>
            <TaskFinder
                ref                 = {taskFinderRef}
                noHeader            = {true}
                showRecent          = {showRecentTasks}
                parentProjectId     = {props.parentProjectId}
                excludedTasksIds    = {props.excludedTasksIds}
                onClickTask         = {onClickTask}
                onTab               = {props.onTab}
                systemStatusFilter  = {SystemStatusFilter.ALL}
            />
        </div>
    )
})

export default FieldSelectTask_Popover_SelectorTaskList
